import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/react'

import CategoryTile from '../CategoryTile/CategoryTile'
import { CategoryTilesProps } from './CategoryTiles.types'

const CategoryTiles = ({ tiles }: CategoryTilesProps) => {
  return (
    <Swiper slidesPerView='auto'>
      {tiles.map((tile, index) => {
        return (
          <SwiperSlide key={index} className='!w-min pr-4 md:pr-6'>
            <CategoryTile {...tile} />
          </SwiperSlide>
        )
      })}
    </Swiper>
  )
}

export default CategoryTiles
